import React, { Component } from 'react';
import LcIcon from '../widget/lc-icon.js';

// 按钮文案理应是字符串，但这里接的是商户配置：对象直接进 JSX 会让整个消息列表崩掉。
function labelOf(button) {
    const text = button && (button.text !== undefined ? button.text : button.label);
    if (typeof text === 'string' || typeof text === 'number') return String(text);
    if (text && typeof text === 'object') {
        const first = text.en || Object.values(text).find((v) => typeof v === 'string');
        return first || '';
    }
    return '';
}

// 没有 id 的按钮用下标当选中标识，否则选中后 state 还是 undefined，等于没选中。
function keyOf(button, index) {
    return button.id !== undefined && button.id !== null && button.id !== '' ? String(button.id) : `#${index}`;
}

export default class ButtonGroupMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedButton: null
        };
    }

    // 本地点击优先（回执还没回来），其次是服务端从历史回填的已选按钮（刷新后保持）。
    currentSelection() {
        if (this.state.selectedButton) return this.state.selectedButton;
        const { selectedId } = this.props;
        return selectedId !== undefined && selectedId !== null && selectedId !== '' ? String(selectedId) : null;
    }

    handleButtonClick = (button, key) => {
        // 防止重复点击；会话已关闭/已封禁时按钮仍显示但不可点
        if (this.currentSelection() || this.props.locked) {
            return;
        }

        this.setState({ selectedButton: key });

        // 发送按钮点击事件到 WebSocket
        if (this.props.onButtonClick) {
            this.props.onButtonClick(button);
        }
    }

    getButtonLayout = (buttonsCount, layout) => {
        // 自动布局逻辑
        if (layout === 'auto') {
            if (buttonsCount <= 2) return 2;
            if (buttonsCount === 3) return 3;
            if (buttonsCount === 4) return 2;
            return 3;
        }

        // 手动指定布局
        if (layout === '1col') return 1;
        if (layout === '2col') return 2;
        if (layout === '3col') return 3;

        return 2; // 默认2列
    }

    render() {
        const { message, layout, locked } = this.props;
        const selectedButton = this.currentSelection();
        const buttons = (Array.isArray(this.props.buttons) ? this.props.buttons : [])
            .filter((b) => b && typeof b === 'object' && labelOf(b) !== '');

        const buttonsPerRow = this.getButtonLayout(buttons.length, layout || 'auto');

        const styles = {
            container: {
                backgroundColor: 'var(--lc-surface, #ffffff)',
                border: 'var(--lc-hairline)',
                borderRadius: 'var(--lc-radius-md)',
                boxShadow: 'var(--lc-shadow-1)',
                padding: 'var(--lc-space-3)',
                margin: 'var(--lc-space-2) 0',
                maxWidth: '320px',
            },
            message: {
                marginBottom: message ? '12px' : '0',
                color: 'var(--lc-text, #1e293b)',
                fontSize: '14px',
                lineHeight: '1.5',
            },
            buttonGrid: {
                display: 'grid',
                gridTemplateColumns: `repeat(${buttonsPerRow}, 1fr)`,
                gap: 'var(--lc-space-2)',
            },
            button: {
                padding: 'var(--lc-space-2) var(--lc-space-3)',
                borderRadius: 'var(--lc-radius-sm)',
                border: 'none',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all var(--lc-dur-base)',
                backgroundColor: 'var(--lc-main)',
                color: 'var(--lc-bubble-user-text, #ffffff)',
                textAlign: 'center',
                outline: 'none',
                userSelect: 'none',
                // 选中态前缀从 '✓ ' 文本换成矢量勾（图标专项）——文本勾的字重与
                // 基线随字体栈走，而且它撑不出居中；flex 行盒让图标与文字一起居中。
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            buttonHover: {
                opacity: 0.9,
                transform: 'translateY(-1px)',
            },
            buttonSelected: {
                // 规范 §4.3：选中态是「主色加深一档 + 前缀勾」，不是另换一个绿。
                // 商户配绿色主题时原来的 #4CAF50 与常态几乎同色，选中状态直接看不出来。
                filter: 'brightness(0.82)',
                cursor: 'default',
            },
            buttonDisabled: {
                opacity: 0.6,
                cursor: 'not-allowed',
            }
        };

        return (
            <div style={styles.container}>
                {message && (
                    <div style={styles.message}>{message}</div>
                )}

                <div style={styles.buttonGrid}>
                    {buttons.map((button, index) => {
                        const key = keyOf(button, index);
                        const isSelected = selectedButton === key;
                        const isDisabled = !isSelected && (!!selectedButton || !!locked);

                        return (
                            <button
                                key={key}
                                style={{
                                    ...styles.button,
                                    ...(isSelected ? styles.buttonSelected : {}),
                                    ...(isDisabled ? styles.buttonDisabled : {})
                                }}
                                onClick={() => this.handleButtonClick(button, key)}
                                disabled={isDisabled}
                                onMouseOver={(e) => {
                                    if (!isDisabled && !isSelected) {
                                        e.target.style.opacity = '0.9';
                                        e.target.style.transform = 'translateY(-1px)';
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (!isDisabled && !isSelected) {
                                        e.target.style.opacity = '1';
                                        e.target.style.transform = 'translateY(0)';
                                    }
                                }}
                            >
                                {isSelected && <LcIcon name="check" size={13} style={{ marginRight: 'var(--lc-space-1)' }} />}
                                <span>{labelOf(button)}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }
}